class AnimateOnScroll {
  constructor() {
    this.image = document.querySelector('.animate-on-scroll')
    this.initObserver()
  }

  initObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.image.classList.add('active')
        }
        // else {
        //   this.image.classList.remove('active') // Optional: remove for one-time animation
        // }
      })
    })

    observer.observe(this.image)
  }
}

export default AnimateOnScroll
